import { ET_TIMEZONE } from "constants/Constants"
import { parseFromTimeZone } from "date-fns-timezone"

export default function(date, config = { timeZone: ET_TIMEZONE}) {
  const { timeZone = ET_TIMEZONE} = config
  return parseFromTimeZone(date, {timeZone})
}
